<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
let { title, subtitle, balancePercent, customClass = "", borderRadius = "8px", glowSize = "35%" } = $props();
const calendarPercent = $derived(100 - balancePercent);
</script>

<InfoCard
	modernStyle
	modernGlowPosition="left"
	modernGlowSize={glowSize}
	noPadding
	{borderRadius}
	customClass="vip-modern-progress-card {customClass}"
>
	<div class="vip-modern-progress-card-inner">
		<div class="vip-modern-progress-card-header">
			<Text type="body" bodySize="medium" bodyWeight="bold" textColor="white">
				{title}
			</Text>
			<Text
				type="body"
				bodySize="xsmall"
				textColor="gray"
				className="vip-modern-progress-card-subtitle"
			>
				{subtitle}
			</Text>
		</div>

		<div class="vip-modern-progress-bar">
			<div class="vip-modern-progress-bar-balance" style="width: {balancePercent}%;"></div>
			<div class="vip-modern-progress-bar-calendar" style="width: {calendarPercent}%;"></div>
		</div>

		<div class="vip-modern-progress-legend">
			<div class="vip-modern-progress-legend-item">
				<span class="vip-modern-progress-swatch vip-modern-progress-swatch-balance"></span>
				<Text type="body" bodySize="small" textColor="white" className="vip-modern-progress-label">
					{balancePercent}% {$t(Verbiage.balance)}
				</Text>
			</div>
			<div class="vip-modern-progress-legend-item">
				<span class="vip-modern-progress-swatch vip-modern-progress-swatch-calendar"></span>
				<Text type="body" bodySize="small" textColor="white" className="vip-modern-progress-label">
					{calendarPercent}% {$t(Verbiage.vip_modern_calendar_label)}
				</Text>
			</div>
		</div>
	</div>
</InfoCard>

<style>
	:global(.vip-modern-progress-card) {

    width: 100%
}

	.vip-modern-progress-card-inner {

    display: flex;

    min-height: 140px;

    flex-direction: column;

    justify-content: space-between;

    gap: 0.75rem;

    padding: 1rem
}

	.vip-modern-progress-card-header {

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 0.75rem
}

	:global(.vip-modern-progress-card-subtitle) {

    white-space: nowrap;

    text-transform: uppercase;

    letter-spacing: 0.025em
}

	.vip-modern-progress-bar {

    position: relative;

    display: flex;

    height: 0.5rem;

    width: 100%;

    overflow: hidden;

    border-radius: 9999px;

    background-color: var(--color-background-900)
}

	.vip-modern-progress-bar-balance {

    background-color: var(--color-accent-100)
}

	.vip-modern-progress-bar-calendar {

    background-color: var(--color-primary-500)
}

	.vip-modern-progress-legend {

    display: flex;

    align-items: center;

    gap: 1rem
}

	.vip-modern-progress-legend-item {

    display: flex;

    align-items: center;

    gap: 0.5rem
}

	.vip-modern-progress-swatch {

    display: block;

    height: 0.625rem;

    width: 0.625rem;

    flex-shrink: 0;

    border-radius: 3px
}

	.vip-modern-progress-swatch-balance {

    background-color: var(--color-accent-100)
}

	.vip-modern-progress-swatch-calendar {

    background-color: var(--color-primary-500)
}

	:global(.vip-modern-progress-label) {

    text-transform: uppercase;

    letter-spacing: 0.025em
}
</style>
